import React from 'react'
import clsx from 'clsx'
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    marginLeft: '2px',
  },
  icon: {
    borderRadius: '50%',
    boxShadow:
      'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      border: '4px solid var(--mcg-blue, #015FFB)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  small: {
    width: 16,
    height: 16,
  },
  medium: {
    width: 20,
    height: 20,
  },
  checkedIcon: {
    backgroundColor: 'var(--mcg-blue, #015FFB)',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  },
  checkedIconSmall: {
    '&:before': {
      width: 16,
      height: 16,
    },
  },
  checkedIconMedium: {
    '&:before': {
      width: 20,
      height: 20,
    },
  },
  labelSmall: {
    fontSize: '12px',
    lineHeight: '150%',
    color: 'var(--mcg-dark, #002E47)',
    /* Body/Body 5 */
    fontFamily: 'Inter',
    fontStyle: 'normal',
  },
  labelMedium: {
    fontSize: '14px',
    lineHeight: '150%',
    color: 'var(--mcg-dark, #002E47)',
    /* Body/Body 5 */
    fontFamily: 'Inter',
    fontStyle: 'normal',
  },
})

function StyledRadio({ size = 'small', ...props }) {
  const classes = useStyles()

  const iconClass = clsx(classes.icon, {
    [classes.small]: size === 'small',
    [classes.medium]: size === 'medium',
  })

  const checkedIconClass = clsx(classes.icon, classes.checkedIcon, {
    [classes.small]: size === 'small',
    [classes.medium]: size === 'medium',
    [classes.checkedIconSmall]: size === 'small',
    [classes.checkedIconMedium]: size === 'medium',
  })

  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={checkedIconClass} />}
      icon={<span className={iconClass} />}
      {...props}
    />
  )
}

const CoreRadioButton = ({
  options = [],
  value = '',
  onChange,
  size = 'small',
}) => {
  const classes = useStyles()

  return (
    <FormControl component="fieldset">
      <RadioGroup value={value} onChange={e => onChange(e.target.value)} row>
        {options.map(option => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<StyledRadio size={size} />}
            label={option.label}
            disabled={option.disabled}
            classes={{
              label:
                size === 'small' ? classes.labelSmall : classes.labelMedium,
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}

export default CoreRadioButton
